import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ICitiesApiClient } from './i-cities-api.client';
import {
  ICityResponse,
  ICreateCityRequest,
  IUpdateCityReqeust,
} from '../dtos';
import { citiesData } from '../data/cities.data';
import { IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { ICreateCityResponse } from '../dtos/responses/create.city.response';


@Injectable({
  providedIn: 'root'
})
export class CitiesInMemoryApiClient implements ICitiesApiClient {
  constructor(protected http: HttpClient) {}

  get(
      paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICityResponse>> {
    return of(citiesData.citiesResponse);
  }

  getById(id: string): Observable<ICityResponse> {
    return of(citiesData.cityResponse);
  }

  create(request: ICreateCityRequest): Observable<ICreateCityResponse> {
    return of(citiesData.createCityResponse);
  }

  update(id: string, request: IUpdateCityReqeust): Observable<void> {
    return of();
  }

  getDistricts(
      cityId: string,
      paginationParameters?: ISoftDeletablePaginationParameters
    ): Observable<IPaginationResponse<ICityResponse>> {
      return of(citiesData.citiesResponse);
    }
}
